import React from "react";
import { formatDateDDMMYYYY, formatDateDDMMYYYYHHMMSS } from "../../Utils/data&dateTime";
import collegeLogo from '../../assets/Images/college-logo.png';
import { toWords } from 'number-to-words';
const DiscountNotice = ({ course, students, isOpen, onClose, noticeData }) => {


    if (!isOpen || !students || students.length === 0) return null;

    const discountAmount = students.discount;
    const payableAmount = students.fee_head_amount - discountAmount;

    // Convert number to words and capitalize first letter
    const payableAmountInWords = toWords(payableAmount)
        .replace(/\b\w/g, c => c.toUpperCase()); // Capitalize first letter  

    const handlePrintNotice = () => {
        const printWindow = window.open("", "_blank", "width=400,height=600");
        printWindow.document.open();
        printWindow.document.write(`
    <html>
      <head>
        <title>Discount Notice</title>
        <style>
          /* POS Thermal Printer (58mm) */
          @media print {
            @page {
             size: 58mm auto;
            margin: 0;
            }
            body {
              margin: 0;
            padding: 0;
            width: 48mm;
            font-family: monospace;
            font-size: 11px;
            line-height: 1.3;

            }
          }


          body {
            width: 48mm;
            margin: 0 auto;
            font-family: monospace, sans-serif;
            font-size: 11px;
            line-height: 1.4;
            text-align: left;
            white-space: normal;
            word-break: keep-all;
            overflow-wrap: anywhere;
          }
              .due-date{
         font-weight: bold
         }

        .collegenameTitle, .affiliateTitle {
         display: block;
         font-size: 12px;
         font-weight: bold;
         text-align: start;
        word-break: break-word; /* allow wrapping */
       }

      .sliptitle{
       text-align: start;}


          .affiliateTitle{
         font-size: 10px;
          font-weight: 500;
          }
          h6 { text-align: center; margin: 2px 0; font-size: 11px; text-decoration: underline; }
          .noticedetails p { margin: 2px 0; font-size: 11px; }
          .approvals { font-size: 11px; margin-top: 30px; }
          strong { font-weight:600; font-size: 11px; }
          .text-center { text-align: center; }
           </style>
           </head>
            <body>
           <div style="width:100%; text-align:center;">
           <h5 class="collegenameTitle" style="margin:0; line-height:1.2;">
           Banaras Institute<br/>
           of Teachers<br/>
           Education, Varanasi<br/>
          </h5>

      <p class="affiliateTitle" style="margin:0; line-height:1.2;">
       (Affiliated with "Mahatma  <br/> Gandhi Kashi Vidyapith,  <br/> Varanasi")
      </p>

        <h6 style="margin:5px 0;"  class="sliptitle">DISCOUNT SLIP</h6>
          </div>


        <div style="margin-top:10px; font-size:11px;">
          <p><strong class="due-date">Date:</strong> ${formatDateDDMMYYYYHHMMSS(students.created_at)}</p>
          <p><strong class="due-date">Document No:</strong><br/> ${students.unique_id}---${students.discount_id}</p>
        </div>

        <div class="noticedetails" style="margin-top:10px;">
          <p><strong class="due-date">${students?.student_name || "____________________"}</strong></p>
          <p><strong class="due-date">${students?.student_course_name}</strong></p>

          <p style="margin-top:10px;">
            A scholarship / discount <br/>  <strong class="due-date">₹${students.discount}</strong>of  has   been granted 
            on the <br/> ${students.fee_head} <strong class="due-date">₹${students.fee_head_amount}</strong>.
          </p>
          <p style="margin-top:5px;">
            Accordingly, the payable <br/> amount towards the <br/>  ${students?.fee_head} <br/>
            is <strong class="due-date">₹${students.fee_head_amount - students.discount} 
            (${toWords(students.fee_head_amount - students.discount).replace(/\\b\\w/g, c => c.toUpperCase())})</strong>.
          </p>
           </div>
         </body>
       </html>
        `);
        printWindow.document.close();

        printWindow.onload = () => {
            printWindow.focus();
            printWindow.print();
            printWindow.close();
        };
    };





    return (
        <div
            id="print-wrap" feenotice-container
            style={{ width: "100%", overflowX: "auto", padding: "20px" }}
        >
            <div className="modal-overlay view-admission-print-modal  feenotice-overlay">
                <div className="print-area feenotice-print-area">
                    <div className="modal-content admissionformprint mt-1 feenotice-container discountnoticecontainer"
                        style={{
                            width: '40vw',
                            height: '78vh',
                            overflowY: "auto",

                        }}>
                        <div className="modal-title d-flex justify-content-end align-items-center">

                            <button
                                className="close-btn no-print"
                                onClick={onClose}
                                aria-label="Close"
                                style={{ color: 'black', border: 'none', background: 'transparent', fontSize: '18px' }}
                            >
                                ✖
                            </button>
                        </div>
                        <div className="feenotice-page">
                            {/* <div className="text-center"><img src={collegeLogo} width={100} height={100} /></div> */}
                            <h5
                                style={{ fontWeight: "bold", color: "black", textAlign: "center" }}
                                className="collegenameTitle mt-2"
                            >
                                Banaras Institute of Teachers Education, Varanasi
                            </h5>
                            <p style={{ fontStyle: "italic", textAlign: "center" }} className="mt-1 mb-5 affiliateTitle">
                                (Affiliated with "Mahatma Gandhi Kashi Vidyapith, Varanasi")
                            </p>

                            <h6
                                style={{ fontWeight: "bold", color: "black", textAlign: "center", textDecoration: 'underline' }}
                                className="collegenameTitle mt-"
                            >
                                DISCOUNT SLIP
                            </h6>
                            <div className="notice-date mt-3 d-flex justify-content-between">
                                <p>
                                    <strong style={{ fontSize: '13px', fontWeight: '600' }}>
                                        Ref No:{" "}
                                        <span style={{ fontWeight: '400' }}>
                                            {`${students.unique_id}---${students.discount_id}`}
                                        </span>

                                    </strong>
                                </p>

                                <p>
                                    <strong style={{ fontSize: '13px', fontWeight: '600' }}>
                                        Date:{" "}
                                        <span style={{ fontWeight: '400' }}>
                                            {formatDateDDMMYYYYHHMMSS(students.created_at)}
                                        </span>
                                    </strong>
                                </p>

                            </div>


                            <div style={{ marginTop: "20px", fontSize: "13px" }} className="noticedetails">
                                <p><strong className="due-date" style={{ fontSize: '11px' }}>Student Name: </strong> {students?.student_name || "____________________"}</p>
                                <p><strong className="due-date">Course: </strong> {students?.student_course_name}</p>
                                {/* <p><strong>Semester:</strong> {student?.semester || "________"}</p>
                            <p><strong>Section:</strong> {student?.section || "________"}</p> */}

                                <p style={{ marginTop: "10px" }}>
                                    A scholarship / discount of <strong className="due-date">₹{discountAmount}</strong> has been granted on the {students.fee_head} <strong className="due-date">₹{students.fee_head_amount}</strong>.
                                </p>
                                <p style={{ marginTop: "5px" }}>
                                    Accordingly, the payable amount towards the {students?.fee_head} is <strong className="due-date">₹{payableAmount} ({payableAmountInWords})</strong>.
                                </p>

                            </div>
                        </div>
                        <div style={{ marginTop: "20px", textAlign: "end" }} className="d-flex justify-content-end gap-2">
                            <button
                                onClick={handlePrintNotice}
                                className="add-btn no-print"
                                style={{ padding: "8px 20px", fontSize: "16px", cursor: "pointer" }}
                            >
                                Print
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DiscountNotice;
